import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti";
import { Medal } from "@phosphor-icons/react";
import { shouldShowOnboarding } from "@/components/OnboardingGuide";

const GOLD = ["#e3b341", "#f5d76e", "#b8860b", "#ffffff"];

export const BadgeCelebration = ({ streak, lang }) => {
  const [badge, setBadge] = useState(null);
  const cs = lang === "cs";

  useEffect(() => {
    if (!streak?.badges || shouldShowOnboarding()) return;
    const seen = JSON.parse(localStorage.getItem("tm_seen_badges") || "[]");
    const earned = streak.badges.filter((b) => b.earned).map((b) => b.days);
    const fresh = earned.filter((d) => !seen.includes(d));
    if (fresh.length === 0) return;
    setBadge(Math.max(...fresh));
    confetti({ particleCount: 140, spread: 100, origin: { y: 0.55 }, colors: GOLD, zIndex: 9999 });
    const end = Date.now() + 2200;
    const frame = () => {
      confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors: GOLD, zIndex: 9999 });
      confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors: GOLD, zIndex: 9999 });
      if (Date.now() < end) requestAnimationFrame(frame);
    };
    frame();
  }, [streak]);

  const close = () => {
    const earned = (streak?.badges || []).filter((b) => b.earned).map((b) => b.days);
    localStorage.setItem("tm_seen_badges", JSON.stringify(earned));
    setBadge(null);
  };

  if (!badge) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-zinc-950/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={close} data-testid="badge-celebration-overlay">
      <div className="bg-zinc-950 border border-amber-500/40 rounded-xl w-full max-w-sm p-8 text-center space-y-4 shadow-[0_0_60px_rgba(227,179,65,0.15)]" onClick={(e) => e.stopPropagation()}>
        <div className="mx-auto w-20 h-20 rounded-full bg-amber-500/10 border border-amber-500/40 flex items-center justify-center animate-bounce">
          <Medal weight="fill" size={40} className="text-amber-400" />
        </div>
        <h3 className="text-2xl font-semibold text-zinc-100">{cs ? "Odznak odemčen!" : "Badge unlocked!"}</h3>
        <p className="text-sm text-zinc-400">
          {cs
            ? `${badge} dní trading deníku v řadě. Disciplína dělá profitabilní tradery — jen tak dál!`
            : `${badge} days of journaling in a row. Discipline builds profitable traders — keep going!`}
        </p>
        <button
          onClick={close}
          data-testid="badge-celebration-close"
          className="bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold px-6 py-2.5 rounded-md text-sm transition-colors"
        >
          {cs ? "Super!" : "Awesome!"}
        </button>
      </div>
    </div>
  );
};
